import * as _ from 'lodash';
import { format } from 'date-fns'
import { buildUrl } from '~/lib/net';
import { addLocationFilter, addTransactionFilter } from './helpers';
import { addUserOrgFilter } from '~/apps/shared/services/qsfilter';
import { defaultTablePageSize } from '~/common/components/consts';


/********************************************
 *************  V2 version  *****************
 ********************************************/

export class AuthEndpoints {
  static login = () => '/api/v2/auth/login';
  static logout = () => '/api/v2/auth/logout';
  static validate = () => `/api/v2/auth/validate/`;
  static forcePasswordChange = () => '/api/v2/auth/change';
}

export class UserEndpoints {
  static getUserById = (userId) => `/api/v2/users/${userId}`;
  static createUser = () => `/api/v2/users/`;
  static updateUser = (userId) => `/api/v2/users/${userId}`;
  static getOrgUsers = (filter, offset, limit) => {
    const qs = addUserOrgFilter({
      offset,
      limit,
    }, filter);
    return buildUrl(`/api/v2/users/`, qs);
  };
  static deleteUser = (userId) => `/api/v2/users/${userId}`;
}

export class OrganizationEndpoints {
  static getOrganizationById = (orgId) => `/api/v2/organizations/${orgId}`;
  static getOrganizations = (offset, limit) =>
    buildUrl(`/api/v2/organizations/`, { offset, limit });
  static findOrganizations = (needle: string, orgType?: string) => {
    const flt: any = {
      limit: 100,
    };

    if (needle) {
      flt.q = needle;
    }
    if (orgType) {
      flt.type = orgType;
    }

    return !_.isEmpty(flt) ?
      buildUrl(`/api/v2/organizations/`, flt) :
      '/api/v2/organizations/';
  };
}

export class LocationEndpoints {
  static getLocationById = (locId) => `/api/v2/locations/${locId}`;
  static getOrgLocations = (orgId, filter, offset, limit) => {
    const _offset = typeof offset === 'number' ? offset : 0;
    const _limit = typeof offset === 'number' ? limit : defaultTablePageSize;
    const opt = addLocationFilter({
      orgId,
      offset: _offset,
      limit: _limit,
    }, filter);

    return buildUrl(`/api/v2/locations/`, opt);
  };
  static findLocations = (needle) => {
    const filter = {
      q: needle,
    };

    return buildUrl(`/api/v2/locations/`, addLocationFilter({}, filter));
  }
}

export class LocationEndpointsV2 {
  static getOrgLocationsV2 = (orgId, filter, offset, limit) => {
    const _offset = typeof offset === 'number' ? offset : 0;
    const _limit = typeof offset === 'number' ? limit : defaultTablePageSize;
    const opt = addLocationFilter({
      orgId,
      offset: _offset,
      limit: _limit,
    }, filter);

    return buildUrl(`/api/v2/organizations/${orgId}/locations/`, opt);
  };

}


export class TransactionEndpoints {
  static getTransactionById = (transactionId) => `/v1/transactions/${transactionId}`;
  static getTransactions = (orgId, filter, offset, limit) => {
    const opts = addTransactionFilter({
      offset,
      limit,
    }, filter);

    return buildUrl(`/v1/transactions`, opts);
  };
  static csvExport = (orgId, dateStart, dateEnd) => {
    return buildUrl(`/v1/transactions/export`, {
      dateStart: format(dateStart, 'YYYY-MM-DD'),
      dateEnd: format(dateEnd, 'YYYY-MM-DD'),
    });
  }
}

export class AccountsEndpoints {
  static kyc = () => `/v1/accounts/kyc`;
  static balance = () => `/v1/accounts/balance`;
}

export class InfoEndpoints {
  static settings = () => '/api/info/settings';
}

export class DepartmentEndpoints {
  static getDepartmentById = (id) => `/api/v2/departments/${id}`;
  static getDepartments = () => `/api/v2/departments/`;
}

export class PasswordReset {
  static sendResetEmail = () => `/api/reset-password`;
  static validateResetCode = (code) => `/api/reset-password/${code}`;
  static setNewPassword = (code) => `/api/reset-password/${code}`;
}
